import axios from "axios";
import { Pagination } from "components";
import React, { Component, useEffect, useState } from "react";

function Temp() {
  const [page, setPage] = useState(1);
  const [list, setList] = useState([])

  function onPageChange(pageNumber) {
    setPage(pageNumber);
  }

  async function fetchCashFlowTableData() {
    try {
      const response = await axios.request(
        {
          method: "GET",
          url: `http://apigateway.osian.local/services/payprompt/api/v1/get-agencies?sort=id&page=${page}&size=10&isDeleted.equals=false`,
        }
      )
      setList(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(()=> {
    fetchCashFlowTableData()
  },[page])

  // useEffect(()=> {
  //   fetchCashFlowTableData()
  // },[])

  return (
    <div className="container mt-5 px-3">
      {list.map((item, index)=> <div>{index+1}{item.agencyName}</div>)}
      <Pagination
        onChangePage={onPageChange}
        totalItemCount={100}
        selectedPage={page}
      />
    </div>
  );
}

export default Temp;
